'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRedux = require('react-redux');


var _containers = require('../../containers');


var _components = require('../../components');


var _messageModal = require('../../redux/modules/messageModal');
var _payments = require('../../redux/modules/payments');






var _userAuthentication = require('../../redux/modules/userAuthentication');



var _manageProperties = require('../../redux/modules/manageProperties');


var _packagesData = require('../../packagesData');






var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _paymentCalculation = require('../../helpers/paymentCalculation');
var _publishAnalytics = require('../../helpers/publishAnalytics');var _publishAnalytics2 = _interopRequireDefault(_publishAnalytics);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Containers
// Components
// Redux
// Helpers
var withPayments = function withPayments(WrappedComponent) {var PaymentContainer = function (_Component) {_inherits(PaymentContainer, _Component);function PaymentContainer() {var _temp, _this, _ret;_classCallCheck(this, PaymentContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
        isPaymentOpen: false,
        isIframeOpen: false,
        showProcessOverlay: false }, _this.

































































      getSelectedPackageData = function (selectedPackage, isAgent) {
        var packages = (0, _packagesData.getPackages)(isAgent, selectedPackage.type);

        var pickedPackage = packages.find(function (pack) {return pack.id === selectedPackage.checked;}) || {};

        if (selectedPackage.type === 'rocket') {
          pickedPackage.property_id = selectedPackage.property_id;
        }

        return pickedPackage;
      }, _this.

      getPackageDataForPayment = function (selectedPackage, isAgent) {var
        period = selectedPackage.period,alternativePeriod = selectedPackage.alternativePeriod;
        var currPackage = _this.getSelectedPackageData(selectedPackage, isAgent);
        var currentPeriod = (0, _get2.default)(currPackage, 'period.' + period) ? period : alternativePeriod;
        var products = (0, _packagesData.buildPackageDataForPayment)(currPackage, currentPeriod);

        if (!!currPackage.type && _this.increaseProductsAmount) {
          _this.increaseProductsAmount(products);
        }

        return { products: products };
      }, _this.

      setProcessOverlayState = function (status) {return _this.setState({ showProcessOverlay: status });}, _this.




















      handlePurchase = function (isSuccessPaid, isRequestFailed, transactionId) {
        if (isSuccessPaid) {
          (0, _publishAnalytics2.default)('success/' + isSuccessPaid, 'payment', _this.props);
          _this.purchaseAnalyics(transactionId);
          _this.setState({ isPaymentOpen: false });
          return _this.props.verifyPayment({
            data: {
              user_id: _this.props.userId,
              locale: _this.props.locale,
              admin: false,
              transactionId: transactionId },

            token: _this.props.userToken }).

          then(function () {return _this.props.authUserByToken(_this.props.updatedToken);}).
          then(function () {return Promise.all([
            _this.props.handlePurchase(_this.props.paidProducts, _this.setProcessOverlayState),
            _this.props.loadUserProperties({ token: _this.props.updatedToken, data: { is_active: true } })]);});

        } else if (isRequestFailed) {
          _this.setState({ isPaymentOpen: false });
          return Promise.
          resolve(_this.props.inquirePayment({
            data: {
              user_id: _this.props.userId,
              locale: _this.props.locale,
              admin: false,
              transactionId: transactionId },

            token: _this.props.userToken })).

          then(_this.props.openMessageModal({
            message:
            _react2.default.createElement(_components.PaymentFailMessage, {
              closeModal: _this.props.hideMessageModal,
              translate: _this.props.packagesTranslate('FailModal') }),


            isCloseButtonInvisible: true,
            className: 'failPaymentModal' }));

        }
        window.hideMessageModal = null;
        window.successPayment = null;
        window.failPayment = null;
        window.isDesktop = null;
        return null;
      }, _this.

      handleSendPayment = function (invoiceDetails) {
        var packages = (0, _packagesData.getPackages)(_this.props.isAgent, _this.props.selectedPackage.type);

        var packageData = _this.getPackageDataForPayment(_this.props.selectedPackage, _this.props.isAgent);

        var couponType = (0, _get2.default)(_this.props, 'discountCoupon.type');var _calculatePaymentAmou =
        (0, _paymentCalculation.calculatePaymentAmountWithVatForRequest)(_this.props.selectedPackage, packages, couponType),priceGrand = _calculatePaymentAmou.priceGrand;

        var companyId = _this.props.companyId;
        var userId = _this.props.userId;var
        period = _this.props.selectedPackage.period;


        var paymentsNumber = (0, _packagesData.getPaymentsNumber)(period, _this.props.selectedPackage.type);

        window.hideMessageModal = function () {
          _this.setState({ isIframeOpen: false });
          _this.props.hideMessageModal();
        };
        window.successPayment = _this.props.successPayment;
        window.failPayment = _this.props.failPayment;
        window.isDesktop = !_this.props.isMobile;

        _this.props.sendPaymentRequest({
          data: Object.assign({},
          packageData,
          invoiceDetails, {
            currency: _packagesData.currency.ILS,
            user_id: userId,
            locale: _this.props.locale,
            payments_number: paymentsNumber,
            amount: priceGrand }),

          token: _this.props.userToken });

      }, _this.

      openDetailsToInvoiceForm = function (packageInstance) {
        if (!_this.props.userId) {
          _this.authInProgress = true;
          _this.packageInstance = packageInstance;
          return _this.props.openAuthenticationModal({ selectedTab: _constants.userAuthenticationTabs.NEW_ACCOUNT });
        }

        if (_this.props.onlyForAgents && !_this.props.isAgent) {
          return _this.props.handleChoosePackage(packageInstance);
        }

        _this.props.openMessageModal({
          message:
          _react2.default.createElement(_containers.DetailsToInvoiceForm, {
            onSubmit: _this.handleSendPayment,
            selectedPackage: _this.props.selectedPackage,
            currentPackageData: _this.getSelectedPackageData(_this.props.selectedPackage, _this.props.isAgent),
            packages: (0, _packagesData.getPackages)(_this.props.isAgent, _this.props.selectedPackage.type),
            translate: _this.props.packagesTranslate('PurchaseSummery'),
            isMobile: _this.props.isMobile,
            isAgent: _this.props.isAgent,
            discountCoupon: _this.props.discountCoupon }),


          className: 'invoiceModal',
          shouldCloseOnOverlayClick: false });

        _this.setState({
          isPaymentOpen: true,
          isIframeOpen: true });


        return null;
      }, _temp), _possibleConstructorReturn(_this, _ret);}PaymentContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var redirectUrl = _ref.redirectUrl,isMessageModalOpen = _ref.isMessageModalOpen,isAuthenticationModalOpen = _ref.isAuthenticationModalOpen,transactionId = _ref.transactionId,isRequestFailed = _ref.isRequestFailed,isSuccessPaid = _ref.isSuccessPaid,paidProducts = _ref.paidProducts,paymentError = _ref.paymentError,userId = _ref.userId;var _state = this.state,isPaymentOpen = _state.isPaymentOpen,isIframeOpen = _state.isIframeOpen;if (!isAuthenticationModalOpen && this.props.isAuthenticationModalOpen && !userId) {this.authInProgress = false;}if (this.props.redirectUrl !== redirectUrl) {this.props.openMessageModal({ message: _react2.default.createElement('iframe', { id: 'payment-iframe', src: redirectUrl, title: 'payments' }, _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })), className: 'invoiceModal', shouldCloseOnOverlayClick: false });this.setState({ isPaymentOpen: true, isIframeOpen: true });}if (isPaymentOpen && !isIframeOpen && !isMessageModalOpen && this.props.isMessageModalOpen) {if (isSuccessPaid) {this.setState({ isPaymentOpen: false, showProcessOverlay: true });}if (isRequestFailed) {this.setState({ isPaymentOpen: false, showProcessOverlay: false });}}if (this.state.isPaymentOpen && !this.state.isIframeOpen && !isMessageModalOpen && this.props.isMessageModalOpen) {return this.handlePurchase(isSuccessPaid, isRequestFailed, transactionId);}return null;};PaymentContainer.prototype.componentDidUpdate = function componentDidUpdate(_ref2) {var userId = _ref2.userId,isAgent = _ref2.isAgent;if (!userId && this.props.userId && this.authInProgress) {if (this.props.onlyForAgents && !this.props.isAgent) {this.props.handleChoosePackage(this.packageInstance);} else {this.openDetailsToInvoiceForm();}this.authInProgress = false;}};PaymentContainer.prototype.purchaseAnalyics = function purchaseAnalyics(transactionId) {var _props = this.props,selectedPackage = _props.selectedPackage,isAgent = _props.isAgent;var packages = (0, _packagesData.getPackages)(isAgent, selectedPackage.type);var couponType = (0, _get2.default)(this.props, 'discountCoupon.type');var _calculatePaymentAmou2 = (0, _paymentCalculation.calculatePaymentAmountWithVatForRequest)(selectedPackage, packages, couponType),priceGrand = _calculatePaymentAmou2.priceGrand,tax = _calculatePaymentAmou2.tax;var currentPackageData = this.getSelectedPackageData(selectedPackage, this.props.isAgent);var period = (0, _get2.default)(selectedPackage, 'period', 1);var propertiesCount = (0, _get2.default)(currentPackageData, 'properties', 1);var type = (0, _get2.default)(currentPackageData, 'type', propertiesCount + ' properties ' + period + 'M');(0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.purchase, value: priceGrand, item: type, transactionId: transactionId });(0, _analyticsManager.trackEcommerce)(transactionId, type, priceGrand, tax, isAgent ? 'agent' : 'user', 1);};PaymentContainer.prototype.

    render = function render() {
      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(WrappedComponent, _extends({
            openDetailsToInvoiceForm: this.openDetailsToInvoiceForm,
            setProcessOverlayState: this.setProcessOverlayState },
          this.props)),

          _react2.default.createElement(_components.PublishProcessOverlay, {
            translate: this.props.translate('publishProperty'),
            isOpen: this.state.showProcessOverlay })));



    };return PaymentContainer;}(_react.Component);


  PaymentContainer.propTypes = {
    handlePurchase: _propTypes2.default.func.isRequired,
    handleChoosePackage: _propTypes2.default.func,
    onlyForAgents: _propTypes2.default.bool,
    locale: _propTypes2.default.string,
    isMobile: _propTypes2.default.bool,
    isRtl: _propTypes2.default.bool,
    openMessageModal: _propTypes2.default.func,
    hideMessageModal: _propTypes2.default.func,
    translate: _propTypes2.default.func,
    packagesTranslate: _propTypes2.default.func,
    userId: _propTypes2.default.string,
    companyId: _propTypes2.default.string,
    userToken: _propTypes2.default.string,
    updatedToken: _propTypes2.default.string,
    isAgent: _propTypes2.default.bool,
    selectedPackage: _propTypes2.default.object,
    paidProducts: _propTypes2.default.array,
    redirectUrl: _propTypes2.default.string,
    paymentError: _propTypes2.default.object,
    transactionId: _propTypes2.default.string,
    iframeLoading: _propTypes2.default.bool,
    isSuccessPaid: _propTypes2.default.bool,
    isRequestFailed: _propTypes2.default.bool,
    discountCoupon: _propTypes2.default.object,
    successPayment: _propTypes2.default.func,
    failPayment: _propTypes2.default.func,
    sendPaymentRequest: _propTypes2.default.func,
    authUserByToken: _propTypes2.default.func,
    loadUserProperties: _propTypes2.default.func,
    verifyPayment: _propTypes2.default.func,
    inquirePayment: _propTypes2.default.func,
    isMessageModalOpen: _propTypes2.default.bool,
    isAuthenticationModalOpen: _propTypes2.default.bool,
    openAuthenticationModal: _propTypes2.default.func };


  var mapStateToProps = function mapStateToProps(state) {return {
      translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
      packagesTranslate: (0, _reduxPagan.getLang)(state.lang, 'PublishProperty'),
      locale: state.lang.locale,
      isMobile: state.windowDimentions.isMobile,
      isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
      userId: (0, _get2.default)(state, 'userAuthentication.data.id'),
      companyId: (0, _get2.default)(state, 'userAuthentication.data.agent_data.agency_id'),
      userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
      isAgent: (0, _get2.default)(state, 'userAuthentication.data.is_agent'),
      selectedPackage: state.payments.selectedPackage,
      paidProducts: state.payments.paidProducts,
      redirectUrl: state.payments.redirectUrl,
      paymentError: state.payments.error,
      transactionId: state.payments.transactionId,
      iframeLoading: state.payments.iframeLoading,
      isSuccessPaid: state.payments.isSuccessPaid,
      isRequestFailed: state.payments.isRequestFailed,
      updatedToken: state.payments.updatedToken,
      discountCoupon: state.discountCoupon.data,
      isMessageModalOpen: state.messageModal.isMessageModalOpen,
      isAuthenticationModalOpen: state.userAuthentication.isAuthenticationModalOpen };};


  var mapDispatchToProps = {
    openMessageModal: _messageModal.openMessageModal,
    hideMessageModal: _messageModal.hideMessageModal,
    successPayment: _payments.successPayment,
    verifyPayment: _payments.verifyPayment,
    inquirePayment: _payments.inquirePayment,
    failPayment: _payments.failPayment,
    authUserByToken: _userAuthentication.authUserByToken,
    loadUserProperties: _manageProperties.loadUserProperties,
    sendPaymentRequest: _payments.sendPaymentRequest,
    openAuthenticationModal: _userAuthentication.openAuthenticationModal };

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentContainer);
};exports.default =

withPayments;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PaymentContainer/PaymentContainer.js
// module id = 570
// module chunks = 0